function _handleNullValue(value) {
  return value === 'null' ? null : value;
}

function _getDefaultValueForReturn(defaultValue) {
  if (defaultValue) {
    const value = defaultValue;
    if (value.includes(',')) {
      return value.split(',');
    }
    if (defaultValue === 'null') {
      return [null];
    }
    return [defaultValue];
  }
  return [];
}

function _getCheckboxChangeWithNoOrder(
givenValue,
selectedValues,
defaultValue,
shouldReturnOptionAllSelection)
{
  const value = _handleNullValue(givenValue);
  const values = [...selectedValues];
  let isAllOptionsWasInSelectedValues = false;

  const index = values.findIndex((v) => String(v).toLowerCase() === 'all');
  if (index !== -1) {
    isAllOptionsWasInSelectedValues = true;
    values.splice(index, 1);
  }

  // - - - - - - - - - - - - - - - - - - - -
  // if shouldReturnOptionAllSelection = true
  // - - - - - - - - - - - - - - - - - - - -

  if (shouldReturnOptionAllSelection) {
    if (String(value).toLowerCase() === 'all' && isAllOptionsWasInSelectedValues && String(defaultValue).toLowerCase() !== 'all') {
      return _getDefaultValueForReturn(defaultValue);
    }
    if (String(value).toLowerCase() === 'all') {
      return [value];
    }

    // remove the option if previously selected
    if (String(value).includes(',')) {
      const valueSplit = value ? value.split(',') : [];
      const hasEvery = valueSplit.every((v) => values.includes(v));
      if (hasEvery) {
        valueSplit.forEach((val) => {
          const i = values.findIndex((v) => v === val);
          values.splice(i, 1);
        });

        if (values.length === 0) {
          return _getDefaultValueForReturn(defaultValue);
        }
        return values;
      }
    } else {
      const i = values.findIndex((v) => v === value);
      if (i !== -1) {
        values.splice(i, 1);

        if (values.length === 0) {
          return _getDefaultValueForReturn(defaultValue);
        }
        return values;
      }
    }

    // add the option if newly selected
    if (String(value).includes(',')) {
      const valueSplit = value ? value.split(',') : [];
      return [
      ...values,
      ...valueSplit];

    }

    return [
    ...values,
    value];

  }

  // - - - - - - - - - - - - - - - - - - - -
  // if shouldReturnOptionAllSelection = false
  // - - - - - - - - - - - - - - - - - - - -

  if (values.length === 0 && String(value).toLowerCase() === 'all' && String(defaultValue).toLowerCase() !== 'all') {
    return _getDefaultValueForReturn(defaultValue);
  }
  if (String(value).toLowerCase() === 'all') {
    return [];
  }

  // remove the option if previously selected
  if (String(value).includes(',')) {
    const valueSplit = value ? value.split(',') : [];
    const hasEvery = valueSplit.every((v) => values.includes(v));
    if (hasEvery) {
      valueSplit.forEach((val) => {
        const i = values.findIndex((v) => v === val);
        values.splice(i, 1);
      });

      if (values.length === 0 && String(defaultValue).toLowerCase() !== 'all') {
        return _getDefaultValueForReturn(defaultValue);
      }
      return values;
    }
  } else {
    const i = values.findIndex((v) => v === value);
    if (i !== -1) {
      values.splice(i, 1);

      if (values.length === 0 && String(defaultValue).toLowerCase() !== 'all') {
        return _getDefaultValueForReturn(defaultValue);
      }
      return values;
    }
  }

  // add the option if newly selected
  if (String(value).includes(',')) {
    const valueSplit = value ? value.split(',') : [];
    return [
    ...values,
    ...valueSplit];

  }

  values.push(value);

  // --

  if (values.length === 1 && values[0] === defaultValue && String(defaultValue).toLowerCase() === 'all') {
    return [];
  }

  return values;
}

export function getCheckboxChange(
givenValue,
selectedValues,
defaultValue,
shouldReturnOptionAllSelection,
filterFacets)
{
  const checkboxChange = _getCheckboxChangeWithNoOrder(
    givenValue,
    selectedValues,
    defaultValue,
    shouldReturnOptionAllSelection
  );

  const filterValues = [].concat(...filterFacets.map((facet) => {
    if (String(facet.value).includes(',')) {
      return facet.value.split(',');
    }
    if (String(facet.value) === 'null') {
      return [null];
    }
    return [facet.value];
  }));

  // $FlowFixMe
  checkboxChange.sort((a, b) => {
    if (filterValues.indexOf(a) > filterValues.indexOf(b)) {
      return 1;
    }
    return -1;
  });

  return checkboxChange;
}

export function isCheckboxChecked(
givenValue,
selectedValues,
shouldReturnOptionAllSelection)
{
  const value = _handleNullValue(givenValue);

  // - - - - - - - - - - - - - - - - - - - -
  // if shouldReturnOptionAllSelection = true
  // - - - - - - - - - - - - - - - - - - - -

  if (shouldReturnOptionAllSelection) {
    if (String(value).includes(',')) {
      return value ? value.split(',').every((val) => selectedValues.includes(val)) : [];
    }
    if (selectedValues.includes(value)) {
      return true;
    }
    return false;
  }

  // - - - - - - - - - - - - - - - - - - - -
  // if shouldReturnOptionAllSelection = false
  // - - - - - - - - - - - - - - - - - - - -

  if (String(value).toLowerCase() === 'all' && selectedValues.length === 0) {
    return true;
  }
  if (String(value).includes(',')) {
    return value ? value.split(',').every((val) => selectedValues.includes(val)) : [];
  }
  if (selectedValues.includes(value)) {
    return true;
  }

  return false;
}